import React from 'react';
import { useContext } from 'react';
import { createContext } from 'react';

const FormContext = createContext({});

const FormProvider = (props: any) => {
	return <FormContext.Provider value={props.value}>{props.children}</FormContext.Provider>;
};

export const useForm = () => {
	const context = useContext(FormContext);

	return context;
};

const Form = ({ props, children, blocks }: any) => {
	const [formState, setFormState] = React.useState('default');

	return (
		<FormProvider value={{ setFormState }}>
			{formState == 'success' && blocks}
			{formState == 'default' && <form>{children}</form>}
		</FormProvider>
	);
};

export default Form;
